import { Component, OnInit } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import { datosProductos } from './survey-check.tree';
import {datosProductosCatalogo} from './survey-check.tree';
import {FlatTreeControl} from '@angular/cdk/tree';
import {MatTreeFlatDataSource, MatTreeFlattener} from '@angular/material/tree';
import { AuthService } from 'app/auth/auth.service';
import * as backInter from 'app/auth/auth-data.model';
import { HttpClient } from '@angular/common/http';
import { DATOS_API } from 'app/auth/auth.datos';
import {TranslateService} from '@ngx-translate/core';
interface FoodNode {
  translate:string, // Auth idiomas 
  id:string,
  name: string,
  hidden: boolean,
  idProducto?:any,
  anio?:any,
  children?: FoodNode[]
}
interface ExampleFlatNode {
  expandable: boolean;
  name: string;
  level: number;
}

interface ProductosNodetmp {
  translate?:string, // Auth idiomas 
  id?:string,
  name: string,
  hidden?: boolean,
  idProducto?:any,
  anio?:any,
  children?: ProductosNodetmp []
}

@Component({
  selector: 'app-survey-check',
  templateUrl: './survey-check.component.html',
  styleUrls: ['./survey-check.component.scss'],
  animations : fuseAnimations
})


export class SurveyCheckComponent implements OnInit {
  ArrayProducto: ProductosNodetmp [] = [];
  showFiller = false;
  dataSourceTree:any;
  treeControl:any;
  arbolProductos: any;
  treeFlattener:any;
  datosUsu: backInter.infoUsuario;
  hasChild = (_: number, node: ExampleFlatNode) => node.expandable;
  cargaCompleta:boolean=false;
  // Variables productos
  hasCertificar = false;
    //productos certificar
    hasCertificar_t0 = false;
    hasCertificar_t1 = false;
    hasCertificar_t2 = false;
    //productos medir
    hasMedir_t0 = false;
    hasMedir_t1 = false;
    hasMedir_t2 = false;
    hasMedir_t3 = false;
    hasMedir_t4 = false;
    hasMedir_t5 = false;
    hasMedir_t6 = false;

    hasPulse = false;
    hasFocus = false;
    hasNorma = false;


  constructor(
    public authService: AuthService,
    private translateSrv: TranslateService,
    private http:HttpClient) {
    
   }

  ngOnInit() {
    this.getProductos();    
  }
  numSeccion=0;

  private _transformer = (node: FoodNode, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      name: node.name,
      translate: node.translate,
      hidden:node.hidden,
      anio:node.anio,
      id:node.id,
      level: level,
    };
  }

  getProductos(){
    let datosUsu = this.authService.getInfoUsuario();
    this.http.get(DATOS_API.url + DATOS_API.endpoints.productos + datosUsu.empresaId)
      .subscribe((data:backInter.infoProductos) => {
        this.datosProd = data;
        console.log(this.datosProd);
        this.filtraProductos();
    }, error  => {
      console.log("error");
    });
  }

  listaProdsCertificar: any[] = [];
  listaProdsMedir: any[] = [];
  datosProd: backInter.infoProductos;
  filtraProductos(){
    if(this.datosProd.productosCertificar.length > 0){ // Pos 0
      this.ArrayProducto.push(datosProductosCatalogo[0]);
      let posCertificar = this.obtenerPos(this.ArrayProducto, "certificar");
      this.datosProd.productosCertificar.forEach(producto => {      
        switch (producto.tipo) {
          case 1: 
            datosProductosCatalogo[1].anio=producto.fechaCertificar;
            datosProductosCatalogo[1].idProducto=producto.idCertificar;
            this.ArrayProducto[posCertificar].children.push(datosProductosCatalogo[1]); 
          break;
          case 2: 
           datosProductosCatalogo[2].anio=producto.fechaCertificar;
           datosProductosCatalogo[2].idProducto=producto.idCertificar
          this.ArrayProducto[posCertificar].children.push(datosProductosCatalogo[2]); 
          break;
          case 3:
            datosProductosCatalogo[3].anio=producto.fechaCertificar;
            datosProductosCatalogo[3].idProducto=producto.idCertificar
            this.ArrayProducto[posCertificar].children.push(datosProductosCatalogo[3]);
          break;
        }
      });
    }
    if(this.datosProd.productosMedir.length > 0 || this.datosProd.productosMedir2.length > 0 ){ // Pos 1
      this.ArrayProducto.push(datosProductosCatalogo[4]);
      let posMedir = this.obtenerPos(this.ArrayProducto, "medir");
      this.datosProd.productosMedir.forEach(producto => {
        this.ArrayProducto[posMedir].children.push(datosProductosCatalogo[5]);
      });
      this.datosProd.productosMedir2.forEach(producto => {
        switch(producto.tipo){
          case 1: this.ArrayProducto[posMedir].children.push(datosProductosCatalogo[6]); break;
          case 2: this.ArrayProducto[posMedir].children.push(datosProductosCatalogo[7]); break;
          case 3: this.ArrayProducto[posMedir].children.push(datosProductosCatalogo[8]); break;
          case 4: this.ArrayProducto[posMedir].children.push(datosProductosCatalogo[9]); break;
          case 5: this.ArrayProducto[posMedir].children.push(datosProductosCatalogo[10]); break;
          case 6: this.ArrayProducto[posMedir].children.push(datosProductosCatalogo[11]);; break;
        }
      });
    }
    if(this.datosProd.productosPulseCheck.length > 0){ // Pos 2
      this.ArrayProducto.push(datosProductos[2]);
    }

    if(this.datosProd.productosFocusArea.length > 0){ // Pos 3
      this.ArrayProducto.push(datosProductosCatalogo[13]);
      let posFocus = this.obtenerPos(this.ArrayProducto, "focus");
      this.datosProd.productosFocusArea.forEach(producto => {
        datosProductosCatalogo[14].anio=producto.fechaFocus;
        datosProductosCatalogo[14].idProducto=producto.idFocusArea;
        this.ArrayProducto[posFocus].children.push(datosProductosCatalogo[14]);
      });
    }
    if(this.datosProd.productosNorma35.length > 0) { // Post 4
      this.ArrayProducto.push(datosProductos[4]);
      let posNom = this.obtenerPos(this.ArrayProducto, "norma35");
      this.datosProd.productosNorma35.forEach(producto => {
        datosProductosCatalogo[16].anio=producto.fechaNorma35;
        datosProductosCatalogo[16].idProducto=producto.idNorma35;
        this.ArrayProducto[posNom].children.push(datosProductosCatalogo[16]);
      });
      
    }
    console.log(this.ArrayProducto);
    this.treeControl = new FlatTreeControl<ExampleFlatNode>(
      node => node.level, node => node.expandable);
      this.treeFlattener = new MatTreeFlattener(
        this._transformer, node => node.level, node => node.expandable, node => node.children);
        this.dataSourceTree = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);
        this.dataSourceTree.data = this.ArrayProducto;
        this.cargaCompleta=true;
    
  }
  obtenerPos(arregloDatos:any, producto:any){
    let pos=0;
    for(let i=0; i< arregloDatos.length; i++){
      if(arregloDatos[i].id == producto){
        pos=i;
        return pos;
      }
    }    

  }


}
